module.exports = __webpack_public_path__ + "static/media/pencil-alt.2f286474.svg";